/**
 * An attachment's note: one line Prest0n wrote saying what the file is (EFAX T16, Miles 2026-10-09: "a note attached
 * to every attachment … so users can hover and preview but also easily see which document is which as it's not clear
 * from the file name a lot of times").
 *
 * The note is the primary's words, carried on the attachment record (`SerializedAttachment.note`); code never writes
 * one (D9). This module only reads it safely for display: a string, one line, at most ATTACHMENT_NOTE_MAX_CHARS.
 * The server bounds it the same way (functions/src/prest0nSession/attachmentNotes.ts), pinned equal by
 * __tests__/anAttachmentShowsItsNote.test.tsx.
 */

/** The longest note shown. The server keeps no longer. */
export const ATTACHMENT_NOTE_MAX_CHARS = 160;

/** PURE. The note to show for an attachment record: one line, trimmed and bounded; '' when it has none. */
export function attachmentNoteOf(att: { note?: unknown } | null | undefined): string {
  const raw = att && typeof att.note === 'string' ? att.note : '';
  const line = raw.replace(/\s+/g, ' ').trim();
  if (line.length <= ATTACHMENT_NOTE_MAX_CHARS) return line;
  return `${line.slice(0, ATTACHMENT_NOTE_MAX_CHARS - 1).trimEnd()}…`;
}
